import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/SurveyPage/components/BuyerRegistration/useStyles.js